export class CameraControl {
  constructor(onTracking, onState, getSettings) { Object.assign(this, { onTracking, onState, getSettings }); this.active = false; this.generation = 0; }
  async start() {
    if (this.active) return;
    if (!window.isSecureContext || !navigator.mediaDevices?.getUserMedia) {
      this.onState({ state: 'error', message: 'Camera requires localhost or HTTPS. A tablet cannot use an insecure LAN address.' }); return;
    }
    this.active = true; const generation = ++this.generation;
    this.onState({ state: 'loading', message: 'Loading local tracking models…' });
    try {
      const check = await fetch('/models/face_landmarker.task', { method: 'HEAD' });
      if (!check.ok) throw new Error('Tracking models are missing. Run bun run setup:vision, then restart the preview.');
      const stream = await navigator.mediaDevices.getUserMedia({ video: { facingMode: 'user', width: { ideal: 480 }, height: { ideal: 360 }, frameRate: { ideal: 15, max: 20 } }, audio: false });
      if (!this.active || generation !== this.generation) { stream.getTracks().forEach(t => t.stop()); return; }
      this.stream = stream;
      this.video = document.createElement('video');
      this.video.muted = true; this.video.playsInline = true; this.video.autoplay = true;
      this.video.setAttribute('aria-hidden', 'true');
      this.video.className = 'tracking-capture'; document.body.append(this.video);
      this.video.srcObject = stream; await this.video.play();
      if (!this.active || generation !== this.generation) return;
      const worker = new Worker('/assets/vision-worker.js'); this.worker = worker;
      this.deadline = setTimeout(() => this.fail('Tracking took too long to load. Try again or use touch controls.'), 30000);
      worker.onerror = () => this.fail('Local tracking could not start in this browser. Try updating Safari or Chrome.');
      worker.onmessage = ({ data }) => {
        if (!this.active || generation !== this.generation) return;
        if (data.type === 'ready') {
          clearTimeout(this.deadline); this.onState({ state: 'tracking', message: 'Find a comfortable position, then calibrate' }); this.schedule(generation);
        } else if (data.type === 'tracking') {
          this.onTracking(data); this.schedule(generation);
        } else if (data.type === 'error') this.fail(`Tracking stopped: ${data.message}`);
      };
      worker.postMessage({ type: 'init' });
      for (const track of stream.getTracks()) track.onended = () => { if (this.active) this.fail('Camera disconnected. Tap Camera to reconnect.'); };
    } catch (error) {
      if (generation !== this.generation) return;
      const message = error.name === 'NotAllowedError' ? 'Camera permission was denied. Enable it in your browser settings.' : error.message;
      this.fail(message);
    }
  }
  schedule(generation) {
    clearTimeout(this.timer);
    this.timer = setTimeout(async () => {
      if (!this.active || generation !== this.generation) return;
      try {
        const bitmap = await createImageBitmap(this.video);
        if (!this.active || generation !== this.generation) { bitmap.close(); return; }
        const { headEnabled, handEnabled } = this.getSettings();
        this.worker.postMessage({ type: 'frame', bitmap, timestamp: performance.now(), headEnabled, handEnabled }, [bitmap]);
      } catch (error) { if (this.active) this.fail(`Camera frame unavailable: ${error.message}`); }
    }, 50);
  }
  fail(message) { this.stop(); this.onState({ state: 'error', message }); }
  stop() {
    this.active = false; ++this.generation; clearTimeout(this.timer); clearTimeout(this.deadline);
    this.worker?.terminate(); this.worker = null;
    this.stream?.getTracks().forEach(t => t.stop()); this.stream = null;
    if (this.video) { this.video.srcObject = null; this.video.remove(); this.video = null; }
    this.onTracking(null); this.onState({ state: 'off', message: 'Camera is off' });
  }
}
